export default "__VITE_ASSET__Cz8s8ar6__"